import { render, staticRenderFns } from "./moralEvaluationBatchStudent.vue?vue&type=template&id=161c8ab8&scoped=true"
import script from "./moralEvaluationBatchStudent.vue?vue&type=script&lang=js"
export * from "./moralEvaluationBatchStudent.vue?vue&type=script&lang=js"
import style0 from "./moralEvaluationBatchStudent.vue?vue&type=style&index=0&id=161c8ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161c8ab8",
  null
  
)

export default component.exports